// frontend/src/components/InstitutionalCTA.jsx

import React from "react";

const InstitutionalCTA = () => {
  return (
    <section className="institutional-cta" style={{ padding: "60px 20px", background: "#f7f9fb" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto", textAlign: "center" }}>
        <h2 style={{ fontSize: "32px", marginBottom: "16px" }}>
          Institutional & Bulk Air Purification Solutions
        </h2>

        <p style={{ fontSize: "18px", color: "#555", maxWidth: "850px", margin: "0 auto 30px" }}>
          Aerzen Air designs high-CADR air purification systems for offices, hospitals,
          educational institutions, and public infrastructure projects across India.
          Our solutions are engineered for real-world Indian AQI conditions and
          scalable multi-location deployments.
        </p>

        <a
          href="mailto:sales@aerzenair.com"
          style={{
            display: "inline-block",
            padding: "14px 28px",
            backgroundColor: "#0a2540",
            color: "#ffffff",
            textDecoration: "none",
            fontSize: "16px",
            borderRadius: "6px",
            fontWeight: "600"
          }}
        >
          Request Institutional / Bulk Proposal
        </a>
      </div>
    </section>
  );
};

export default InstitutionalCTA;
